/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: false,
  apiUrl: "https://api.masthuman.com/v1/admin/",
  version: '1.0.0',
  googleApiKey: 'AIzaSyBJoxX7uhZBDH04ILbZ72PxMwI38pjLwfo',
  s3BucketUrl: 'https://mast-dev.s3-us-west-1.amazonaws.com/',
  employerRoleId: 8,
  csoNgoRoleId: 9
};
